import { useTranslation } from '../../../translation/TranslationContext';
import { getConditionSplitLabel } from '../../conditions/orderCondition.utils';
import { useOrderConditionContext } from '../../contexts/OrderCondition.context';
import { ALL_ORDER_CONDITIONS_ID } from '../../contexts/hooks/useSelectedOrderCondition';
import { Section } from '../orderProducts.types';
import { filterSectionsBySelectedCondition } from '../orderProducts.utils';

const useOrderProductsConditionFilter = (sections: Section[]) => {
  const { translate } = useTranslation();
  const { orderConditions, selectedCondition, selectCondition } = useOrderConditionContext();

  return {
    conditionSections: filterSectionsBySelectedCondition(sections, selectedCondition?.id),
    selectedConditionId: selectedCondition?.id,
    selectedConditionLabel: selectedCondition
      ? getConditionSplitLabel(selectedCondition, translate)
      : undefined,
    conditionOptions: orderConditions.map((condition) => ({
      id: condition.id,
      label: getConditionSplitLabel(condition, translate),
    })),
    selectCondition,
    clearSelectedCondition: () => selectCondition(ALL_ORDER_CONDITIONS_ID),
  };
};

export default useOrderProductsConditionFilter;
